import PropTypes from "prop-types";
import React, { useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Spinners from "../../components/Common/Spinner";
import { useNavigate } from 'react-router-dom'

import { useSelector, useDispatch } from "react-redux";

import './test.css'
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import { Button, Col, Row, Modal, ModalHeader, ModalBody, Card, CardBody, Badge } from "reactstrap";

import axios from "axios";
import * as url from "../../../src/helpers/url_helper";
import { getLoggedInUser, getRefreshToken } from "../../helpers/fakebackend_helper"
//i18n


const DemoTest = () => {



  const [isLoading, setLoading] = useState(true);
  const [activeQuestion, setActiveQuestion] = useState(0)


  const [showResult, setShowResult] = useState(false)
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen2, setModalOpen2] = useState(false);

  const [modalOpen1, setModalOpen1] = useState(false);
  const [modalOpen3, setModalOpen3] = useState(false);


  const navigate = useNavigate();


  const [answeredCount, setAnsweredCount] = useState(0)
  const [markedCount, setMarkedCount] = useState(0)
  const [notAnsweredCount, setNotAnsweredCount] = useState(0)
  const [notAttendedCount, setNotAttendedCount] = useState(0)


  const [examName, setExamName] = useState("")
  const [totalQuestion, setTotalQuestion] = useState("0")

  const [maxMarks, setMaxMarks] = useState("0")


  const [result, setResult] = useState({
    score: 0,
    correctAnswers: 0,
    wrongAnswers: 0,
  })

  const toggleModal = () => {
    onClickNext(activeQuestion)
    setModalOpen(!modalOpen);
  };
  const toggleModal1 = () => {
    onClickNext(activeQuestion)
    setModalOpen2(!modalOpen2);
  };
  const toggleModal2 = () => {
    // onClickNext(activeQuestion)
    setModalOpen3(!modalOpen3);
  };

  useEffect(() => {

    const disableBackButton = (e) => {
      e.preventDefault(); // Prevent default behavior of back button
      window.history.forward(); // Move forward in history
    };
    // Push a new state to prevent going back
    window.history.pushState(null, "", window.location.href);

    window.onpopstate = function () {
      window.history.pushState(null, "", window.location.href)
    }
    // Add an event listener for the popstate event
    // window.addEventListener('popstate', disableBackButton);

    // Cleanup function to remove event listener
    // return () => {
    //   window.removeEventListener('popstate', disableBackButton);
    // };
  }, []);

  const [questions, setQuestions] = useState([])
  const [testID, setTestID] = useState(0)




  useEffect(() => {
    bindExamQuestions()
        
  }, [])





  async function bindExamQuestions() {
    const user = getLoggedInUser()
    setLoading(true)
    const params = {
      "stid": Number(user.UserInfo.stid),
      "type_id":3
    };

    const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo?.accessToken) } };

    try {
      const response = await axios.post(url.BASE_URL + 'subscription/getDemoQuestionList', params, config);
      if (response && response?.data?.body?.statusFlag === 3) {
        toast.error(response.data.body.message, { autoClose: 2000 });
        localStorage.removeItem("authUser");
        window.location.reload();
        return;
      }

      if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
        const refresh = await getRefreshToken();

        if (refresh) {
          if (Number(refresh) === constants.invalidRefreshToken) {
            logoutUser();
          } else {
            await bindExamQuestions();
          }
        }
      }

      if (response?.data?.body?.statusFlag === 1) {
        var qaList = response?.data?.body?.questions;
        setQuestions(qaList)
        qaList[activeQuestion]['attended'] = 1


        setNotAttendedCount(qaList.filter(e => e?.attended != 1)?.length);

   
        setTotalQuestion(response?.data?.body?.totalQuestion)



        // setSeconds(examDetails?.secs)

        setTestID(response?.data?.body?.testID)


      } else {
        toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
      setLoading(false)
    } catch (error) {
      // Handle error
      console.error("Change Password API Error:", error);
      // navigate('/dashboard')
    } finally {

    }
  }

 
  const onClickNext = (index) => {
    saveExamDetails()




    setAnsweredCount(questions.filter(e => e?.answered == 1)?.length);
    // setMarkedCount(questions.filter(e => e?.marked == 1)?.length);
    setNotAnsweredCount(questions.filter(e => e?.attended == 1 && (e?.answered != 1 && e?.marked != 1))?.length);


    if (activeQuestion !== questions.length - 1) {

      setActiveQuestion(index)

      setNotAttendedCount(questions.filter(e => e?.attended != 1)?.length > 0 ? questions.filter(e => e?.attended != 1)?.length : 0);
      setQuestions(prevArray => {
        const newArray = [...prevArray]; // Create a copy of the original array  

        newArray[index]['attended'] = 1

        return newArray; // Return the new array
      });

    } else {
      setActiveQuestion(0)

    }
  }

  const onClickClear = () => {

    setQuestions(prevArray => {
      const newArray = [...prevArray]; // Create a copy of the original array

      for (var i = 0; i < newArray[activeQuestion]['optionList'].length; i++) {
        newArray[activeQuestion]['optionList'][i]['selectedanswer'] = 0
        newArray[activeQuestion]['optionList'][i]['qa_answerflag'] = 0
      }
      newArray[activeQuestion]['attended'] = 1
      newArray[activeQuestion]['answered'] = 0
      newArray[activeQuestion]['marked'] = 0


      return newArray; // Return the new array
    });

  }

  async function saveExamDetails() {
    const user = getLoggedInUser()

    var options = questions[activeQuestion]['optionList'];
    var selectedAns = options.find(e => e?.selectedanswer == 1);
    const data = {
      "stid": Number(user.UserInfo?.stid),
      "testid": Number(testID),
      "qid": Number(questions[activeQuestion]['qid']),
      "qaid": selectedAns?.qaid ? Number(selectedAns?.qaid) : 0,
      "reviewmark": questions[activeQuestion]['marked'] ? Number(questions[activeQuestion]['marked']) : 0
    };

    const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo?.accessToken) } };

    try {
      const response = await axios.post(url.BASE_URL + 'exam/saveOnlineExam', data, config);
      if (response && response?.data?.body?.statusFlag === 3) {
        toast.error(response.data.body.message, { autoClose: 2000 });
        localStorage.removeItem("authUser");
        window.location.reload();
        return;
      }

      if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
        const refresh = await getRefreshToken();

        if (refresh) {
          if (Number(refresh) === constants.invalidRefreshToken) {
            logoutUser();
          } else {
            await saveExamDetails();
          }
        }
      }

      if (response?.data?.body?.statusFlag === 1) {



      } else {
        toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (error) {
      // Handle error
      //console.error("Change Password API Error:", error);
    } finally {

    }
  }
  



  // useEffect(() => {

  //   if (testID != 0) {
  //     if (Number(hours) === 0 && Number(minutes) === 0 && Number(seconds) === 0) {
  //       // setTimeout(() => {

  //       //   // setModalOpen1(!modalOpen1);
  //       // }, 1000)
  //       // setStatusFlag1(2)
  //       submitTest(2)
  //     }
  //   }

  // }, [hours, minutes, seconds, testID])


  const gotoTest = () => {
    navigate('/dashboard')
  }





  useEffect(() => {
    document.addEventListener("contextmenu", handlecontextmenu)

    const handleKeyDown = (event) => {

      if (event.code === "MetaLeft" && event.keyCode === 91 && event.metaKey === true) {
        event.preventDefault()
      }


      // Ctrl + A 
      if (event.ctrlKey && (event.key === 'a' || event.key === 'A')) {
        // Prevent default behavior for Ctrl+A (select all)
        event.preventDefault();
      }
      // Ctrl + c
      if (event.ctrlKey && (event.key === 'c' || event.key === 'C')) {
        // Prevent default behavior for Ctrl+C (copy)
        event.preventDefault();
      }
      // // Inspect disabled
      if (event.ctrlKey && event.shiftKey && (event.key == 'i' || event.key === 'I')) {
        event.preventDefault();
      }
      if ((event.ctrlKey || event.metaKey) && (event.keyCode === 91)) { // Ctrl + S or Command + S
        event.preventDefault();
        // alert('Screenshots are disabled.');
      }
      if (event.key === "Meta") {
        event.preventDefault();
        // alert('=-=-=')
      }
      if ((event.key === "PrintScreen" || event.key === 'Meta') && (event.keyCode === 44 || event.keyCode === 91)
        && event.metaKey === 'true') {
        event.preventDefault();
        // alert('=-=-=')
      }

    }
    window.addEventListener('keydown', handleKeyDown);
    // Add event listener to capture Ctrl+A and Ctrl+C keydown events
    document.addEventListener('keydown', handleKeyDown);

    // document.addEventListener('keyup', (e) => {
    // console.log('e=====>', e)
    //     if (e.key == 'PrintScreen') {
    //         navigator.clipboard.writeText('');
    //         alert('Screenshots disabled!');
    //     }
    //     if((e.metaKey) && (e.keyCode == 91)){
    //         navigator.clipboard.writeText('');

    //         alert('dis')
    //     }
    //     if (event.key === 's' && event.metaKey && event.shiftKey) {
    //         event.preventDefault(); // Prevent the default behavior
    //         console.log('Windows + Shift + S is restricted');
    //     }
    // });
    document.addEventListener('keydown', function (event) {
      // Check if the key combination is Windows + PrintScreen
      if (event.key === 'PrintScreen' && (event.metaKey || event.ctrlKey)) {
        event.preventDefault(); // Prevent the default behavior
        console.log('Windows + PrintScreen is restricted');
      }

      // Check if the key combination is Windows + Shift + S
      if (event.key === 's' && event.metaKey && event.shiftKey) {
        event.preventDefault(); // Prevent the default behavior
        console.log('Windows + Shift + S is restricted');
      }
    });

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      // document.removeEventListener("contextmenu",handlecontextmenu)
      document.removeEventListener('keydown', handleKeyDown);
    }


  }, [])

  const handlecontextmenu = (e) => {
    e.preventDefault()
  }

  const handleDragStart = (e) => {
    e.preventDefault(); // Prevent default drag behavior
  };
  async function submitTest(stflag) {
    const user = getLoggedInUser()
    if (questions && questions.length > 0) {
      var options = questions[activeQuestion]['optionList'];

    }
    var selectedAns = options.find(e => e?.selectedanswer == 1);
    const data = {
      "stid": Number(user.UserInfo?.stid),
      // "stid": 50,
      "testid": Number(testID)

    };

    const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo?.accessToken) } };

    try {
      const response = await axios.post(url.BASE_URL + 'exam/submitOnlineExam', data, config);
      if (response && response?.data?.body?.statusFlag === 3) {
        toast.error(response.data.body.message, { autoClose: 2000 });
        localStorage.removeItem("authUser");
        window.location.reload();
        return;
      }

      if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
        const refresh = await getRefreshToken();

        if (refresh) {
          if (Number(refresh) === constants.invalidRefreshToken) {
            logoutUser();
          } else {
            await submitTest();
          }
        }
      }

      if (response?.data?.body?.statusFlag === 1) {
        // toast.success(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
        // navigate(
        //   `/summary`
        // )
    
        if (testID && (stflag === 1)) {
         
          navigate('/summary', { state: { testid: Number(testID), type: 3 } })
        } else if (testID && (stflag === 2)) {

     
          // navigate('/summary', { state: { testid: Number(testID) } })
          setModalOpen1(!modalOpen1);
        } else if (testID && (stflag === 3)) {
     
          navigate('/summary', { state: { testid: Number(testID), type: 3  } })
        }
        //  else {
        //   navigate("/dashboard")
        // }
      } else {
        toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (error) {
      // Handle error
      //console.error("Change Password API Error:", error);
    } finally {

    }
  }

  const markForReview = () => {
    // setMarkedCount(questions.filter(e => e?.marked == 1)?.length);
    setQuestions(prevArray => {
      const newArray = [...prevArray]; // Create a copy of the original array


      newArray[activeQuestion]['marked'] = 1
      return newArray; // Return the new array
    });
  }
  useEffect(() => {
    setMarkedCount(questions.filter(e => e?.marked == 1)?.length);
    setAnsweredCount(questions.filter(e => e?.answered == 1)?.length);
    setNotAttendedCount(questions.filter(e => e?.attended != 1)?.length);
    setNotAnsweredCount(questions.filter(e => e?.attended == 1 && (e?.answered != 1 && e?.marked != 1))?.length);
  }, [questions])


  const onClickPrevious = () => {


    if (activeQuestion !== 0) {
      setActiveQuestion(prev => prev - 1);
    } else {
      setActiveQuestion(questions.length - 1);
    }
  };
  const onClickSubmit = () => {
    navigate("/login")
  };

  const onAnswerSelected = (answer, index) => {

    // setNotAnsweredCount(questions.filter(e => e?.attended == 1 && (e?.answered != 1 && e?.marked != 1))?.length);

    // setNotAttendedCount(questions.filter(e => e?.attended != 1)?.length > 0 ? questions.filter(e => e?.attended != 1)?.length : 0);
    setQuestions(prevArray => {
      const newArray = [...prevArray]; // Create a copy of the original array

      for (var i = 0; i < newArray[activeQuestion]['optionList'].length; i++) {
        newArray[activeQuestion]['optionList'][i]['selectedanswer'] = 0
      }
      newArray[activeQuestion]['optionList'][index]['selectedanswer'] = 1

      newArray[activeQuestion]['answered'] = 1
      return newArray; // Return the new array
    });
    // onClickNext(index)

    // questions[activeQuestion]['optionList'][index]['selectedanswer'] = 1
  }

  const addLeadingZero = (number) => (number > 9 ? number : `0${number}`)

  //meta title
  // document.title = "Masters | Online Test";


  return (
    <React.Fragment>

      <div className="page-content pt-1"
      // onCopy={(event) => event.preventDefault()} onDragStart={handleDragStart} onKeyDown={(event) => {
      //   event.preventDefault();
      // }}
      >
        <Row>
          {isLoading ? (
            <Spinners setLoading={setLoading} />
          ) : (
            <Card>
              <CardBody>
                <Row>
                  <Col lg="6">
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{examName}</h5>
                      </div>
                      <div className="text-muted">
                        <h8>
                          Total Questions
                          <span className="m-2">
                            <Badge className="btn btn-blue custom-badge">
                              <b>{totalQuestion}</b>
                            </Badge>
                          </span>
                        </h8>
                    
                      </div>
                    </div>
                  </Col>
                  <Col lg="6">
                    <Row>
                      <Col>
                        <div className="activeques">
                          <span className="active-question-no">{addLeadingZero(activeQuestion + 1)}</span>
                          <span className="total-question">/{addLeadingZero(questions.length)}</span>
                        </div>
                      </Col>

                 
                    </Row>
                  </Col>
                </Row>
                <div style={{ borderTop: '1px solid grey', margin: '8px' }}></div>
                <Row>
                  <Col xs="12">
                    <Row>

                      {/* <CardBody className="mini-stats-wid"> */}
                      <div>
                        <Badge pill color="success" className="me-1">
                          <b>{answeredCount}</b> - Answered
                        </Badge>
                        <Badge pill color="btn btn-yellow custom-badge" className="me-1 btn btn-yellow custom-badge">
                          <b>{markedCount}</b> - Marked
                        </Badge>

                        <Badge pill color="btn btn-blue custom-badge" className="me-1 btn btn-blue custom-badge">
                          <b>{notAnsweredCount}</b> -  Not Answered
                        </Badge>
                        <Badge pill color="btn btn-lightblue custom-badge" className="me-1 btn btn-lightblue custom-badge" >
                          <b>{notAttendedCount}</b> - Not Attended

                        </Badge>
                      </div>
                      {/* </CardBody> */}

                    </Row>
                  </Col>
                </Row>

                <Row>

                  <Col xs="12" lg="8">
                    <div className="quiz-container" >
                      {!showResult ? (
                        <div className="m-4">
                          <div className="cls-div-qn">
                            {questions[activeQuestion]?.qt_contentflag == 1 ? (
                              <div className='ck-content' dangerouslySetInnerHTML={{ __html: questions[activeQuestion]?.qt_text }} />
                            ) : (
                              <h2>{questions[activeQuestion]?.qt_text}</h2>
                            )}
                            <ul>
                              {questions[activeQuestion]?.optionList?.map((answer, index) => (

                                <div className="row" key={answer} >
                                  <li
                                    className={answer?.selectedanswer === 1 ? 'selected-answer col-11 li-option' : 'col-11 li-option'}
                                    style={{ cursor: 'pointer' }}
                                    // onMouseEnter={(e) => e.target.style.backgroundColor = 'lightgreen'}
                                    // onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                    onClick={() => onAnswerSelected(answer, index)}
                                  >
                                    <input
                                      type="radio"
                                      name="answer"
                                      style={{ verticalAlign: 'middle' }}
                                      value={answer?.qaid}
                                      onChange={() => onAnswerSelected(answer, index)}
                                      checked={answer?.selectedanswer === 1}
                                    />
                                    {answer.qa_contentflag == 1 ? (
                                      <div className='ck-content' dangerouslySetInnerHTML={{ __html: answer.qa_name }} />
                                    ) : (
                                      <span> {answer.qa_name}</span>
                                    )}
                                  </li>
                                </div>
                              ))}
                            </ul>

                          </div>
                          <div style={{ justifyContent: 'right' }}>


                            <div onClick={() => onClickClear()} className="btn btn-soft-primary clrresponse">Clear Response</div>

                            {activeQuestion === 0 ? <div style={{ display: 'hidden', visibility: 'hidden', opacity: '0' }} onClick={onClickPrevious} className="btn btn-soft-primary">Previous</div> : <div onClick={onClickPrevious} className="btn btn-soft-primary">Previous</div>}




                            <div onClick={() => markForReview()} className="btn btn-soft-warning">Mark for Review</div>


                            {activeQuestion === questions.length - 1 ? "" : <div onClick={() => onClickNext(activeQuestion + 1)} className="btn btn-soft-primary">Next</div>}

                          </div>
                        </div>
                      ) : (
                        <div className="result">
                          <h3>Result</h3>
                          <p>
                            Total Question: <span>{questions.length}</span>
                          </p>
                          <p>
                            Total Score:<span> {result.score}</span>
                          </p>
                          <p>
                            Correct Answers:<span> {result.correctAnswers}</span>
                          </p>
                          <p>
                            Wrong Answers:<span> {result.wrongAnswers}</span>
                          </p>
                        </div>
                      )}
                    </div>

                  </Col>
                  <Col xs="12" lg="4">
                    <Card style={{ width: '100%', height: 'calc(62vh - 100px)', overflowY: 'auto', padding: '20px', marginTop: '10px' }}>
                      <Row>
                        {questions?.map((e, index) => (

                          activeQuestion + 1 == index + 1 ? (
                            <div key={"button_" + index} style={{ width: '10%', background: 'rgb(164 174 229 / 40%)', margin: '3px', padding: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'black' }} className="cursor-focus" >
                              {index + 1}
                            </div>
                          )
                            :

                            e.attended == 1 && e.answered != 1 && e.marked != 1 && activeQuestion + 1 != index + 1 ? (
                              <div key={"button_" + index} style={{ width: '10%', background: 'blue', margin: '3px', padding: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white' }} className="cursor-focus" onClick={() => onClickNext(index)}>
                                {index + 1}
                              </div>
                            ) : e.attended == 1 && e.answered == 1 && e.marked != 1 ? (
                              <div key={"button_" + index} style={{ width: '10%', background: '#34c38f', margin: '3px', padding: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white' }} className="cursor-focus" onClick={() => onClickNext(index)}>
                                {index + 1}
                              </div>
                            ) : e.marked == 1 ? (
                              <div key={"button_" + index} style={{ width: '10%', background: 'orange', margin: '3px', padding: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white' }} className="cursor-focus" onClick={() => onClickNext(index)}>
                                {index + 1}
                              </div>
                            ) : (
                              <div key={"button_" + index} style={{ width: '10%', background: '#f0f2fd66', margin: '3px', padding: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#000' }} className="cursor-focus

" onClick={() => onClickNext(index)}>
                                {index + 1}
                              </div>
                            )


                        ))}
                      </Row>
                    </Card>


                    <Button className="btn btn-silk custom-badge position-absolute bottom-0 end-0" style={{ marginBottom: '1px' }} onClick={toggleModal}>
                      Submit Test
                    </Button>
                    <Modal isOpen={modalOpen} toggle={toggleModal} centered>
                      <ModalHeader toggle={toggleModal}>Exam Summary</ModalHeader>
                      <ModalBody>
                        <div className="row">
                          <div className="col-md-4 text-end">
                            <p><strong>Exam Name:</strong></p>
                            <p><strong>No. of Questions:</strong></p>
                            <p><strong>Answered:</strong></p>
                            <p><strong>Marked For Review:</strong></p>
                            <p><strong>Not Answered:</strong></p>
                            {/* <p><strong>Marked & Answered:</strong></p> */}
                            <p><strong>Not Attended:</strong></p>
                          </div>
                          <div className="col-md-8">
                            <p className="no-wrap">{'Demo'}</p>
                            <p>{totalQuestion}</p>
                            <p>{answeredCount}</p>
                            <p>{markedCount}</p>
                            <p>{notAnsweredCount}</p>
                            {/* <p>{markedAnsweredCount}</p> */}
                            <p>{notAttendedCount}</p>
                          </div>
                        </div>
                        <div className="text-center mt-3">
                          <h5>Are you sure want to submit?</h5>
                          <div className="d-flex justify-content-center">
                            <Button color="primary" onClick={() => {
                              // setStatusFlag1(1)
                              submitTest(1)
                            }} className="me-2 modalbtn">Yes</Button>
                            <Button color="secondary" onClick={toggleModal} className="modalbtn">No</Button>
                          </div>
                        </div>
                      </ModalBody>
                    </Modal>
                
               
                    <Modal isOpen={modalOpen3} toggle={toggleModal2} centered backdrop="static">
                      <ModalHeader >Exam Summary</ModalHeader>
                      <ModalBody>
                        <div className="row">
                          <div className="col-md-4 text-end">
                            <p><strong>Exam Name:</strong></p>
                            <p><strong>No. of Questions:</strong></p>
                            <p><strong>Answered:</strong></p>
                            <p><strong>Marked For Review:</strong></p>
                            <p><strong>Not Answered:</strong></p>
                            {/* <p><strong>Marked & Answered:</strong></p> */}
                            <p><strong>Not Attended:</strong></p>
                          </div>
                          <div className="col-md-8">
                            <p className="no-wrap">{examName}</p>
                            <p>{totalQuestion}</p>
                            <p>{answeredCount}</p>
                            <p>{markedCount}</p>
                            <p>{notAnsweredCount}</p>
                            {/* <p>{markedAnsweredCount}</p> */}
                            <p>{notAttendedCount}</p>
                          </div>
                        </div>
                        <div className="text-center mt-3">
                          {/* <h5>Are you sure want to submit?</h5> */}
                          <div className="d-flex justify-content-center">
                            <Button color="primary" onClick={() => {
                              startTimer1()
                            }} className="me-2 modalbtn">Resume test</Button>
                            <Button color="secondary" onClick={gotoTest} className="modalbtn">Go to Home</Button>
                          </div>
                        </div>
                      </ModalBody>
                    </Modal>

                  </Col>
                </Row>

              </CardBody>
            </Card>
          )}
        </Row>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
}
DemoTest.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};


export default DemoTest;
